var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToDoList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.584 90 H 17.415 c -3.607 0 -6.541 -2.935 -6.541 -6.542 V 17.999 c 0 -3.607 2.934 -6.541 6.541 -6.541 h 12.464 c 1.648 0 2.983 1.336 2.983 2.983 s -1.336 2.983 -2.983 2.983 H 17.415 c -0.317 0 -0.574 0.258 -0.574 0.574 v 65.459 c 0 0.317 0.258 0.575 0.574 0.575 h 55.169 c 0.317 0 0.575 -0.258 0.575 -0.575 V 17.999 c 0 -0.317 -0.258 -0.574 -0.575 -0.574 H 60.121 c -1.648 0 -2.983 -1.336 -2.983 -2.983 s 1.335 -2.983 2.983 -2.983 h 12.463 c 3.607 0 6.542 2.934 6.542 6.541 v 65.459 C 79.126 87.065 76.191 90 72.584 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.49 8.224 c -0.4 -3.784 -3.6 -6.733 -7.49 -6.733 s -7.09 2.949 -7.49 6.733 h -4.391 c -2.914 0 -5.276 2.362 -5.276 5.276 v 5.464 h 34.314 v -5.464 c 0 -2.914 -2.362 -5.276 -5.276 -5.276 H 52.49 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.157 20.456 H 27.843 c -0.824 0 -1.492 -0.668 -1.492 -1.492 v -5.464 c 0 -3.732 3.036 -6.768 6.768 -6.768 h 3.149 C 37.287 2.813 40.831 0 45 0 s 7.713 2.813 8.731 6.733 h 3.15 c 3.731 0 6.767 3.036 6.767 6.768 v 5.464 C 63.648 19.789 62.98 20.456 62.157 20.456 z M 29.335 17.473 h 31.33 v -3.972 c 0 -2.087 -1.698 -3.785 -3.784 -3.785 H 52.49 c -0.763 0 -1.403 -0.576 -1.483 -1.335 C 50.68 5.304 48.099 2.983 45 2.983 s -5.681 2.321 -6.007 5.398 c -0.08 0.759 -0.72 1.335 -1.483 1.335 h -4.391 c -2.087 0 -3.785 1.698 -3.785 3.785 V 17.473 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.714 41.026 c -0.085 0 -0.17 -0.003 -0.256 -0.011 c -0.926 -0.079 -1.763 -0.586 -2.262 -1.371 l -3.079 -4.839 c -0.884 -1.39 -0.474 -3.234 0.916 -4.119 c 1.389 -0.883 3.234 -0.474 4.119 0.916 l 0.982 1.544 l 4.497 -4.944 c 1.109 -1.219 2.996 -1.308 4.214 -0.2 c 1.219 1.109 1.308 2.996 0.2 4.214 l -7.125 7.832 C 29.353 40.674 28.55 41.026 27.714 41.026 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.714 60.001 c -0.085 0 -0.17 -0.004 -0.256 -0.011 c -0.926 -0.08 -1.763 -0.587 -2.262 -1.371 l -3.079 -4.839 c -0.884 -1.39 -0.474 -3.234 0.916 -4.119 c 1.389 -0.885 3.234 -0.474 4.119 0.916 l 0.983 1.544 l 4.497 -4.943 c 1.109 -1.219 2.996 -1.308 4.214 -0.199 c 1.219 1.108 1.308 2.995 0.2 4.214 l -7.125 7.832 C 29.353 59.649 28.55 60.001 27.714 60.001 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.714 78.975 c -0.085 0 -0.17 -0.004 -0.256 -0.011 c -0.926 -0.08 -1.763 -0.587 -2.262 -1.371 l -3.079 -4.839 c -0.884 -1.39 -0.474 -3.234 0.916 -4.119 c 1.389 -0.885 3.234 -0.474 4.119 0.916 l 0.982 1.544 l 4.497 -4.944 c 1.109 -1.218 2.996 -1.307 4.214 -0.2 c 1.219 1.109 1.308 2.996 0.2 4.215 l -7.125 7.833 C 29.353 78.624 28.55 78.975 27.714 78.975 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.365 37.469 H 45.324 c -1.648 0 -2.983 -1.336 -2.983 -2.983 c 0 -1.648 1.336 -2.983 2.983 -2.983 h 20.041 c 1.648 0 2.983 1.336 2.983 2.983 C 68.349 36.133 67.013 37.469 65.365 37.469 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.365 56.443 H 45.324 c -1.648 0 -2.983 -1.335 -2.983 -2.983 c 0 -1.648 1.336 -2.983 2.983 -2.983 h 20.041 c 1.648 0 2.983 1.335 2.983 2.983 C 68.349 55.108 67.013 56.443 65.365 56.443 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.365 75.417 H 45.324 c -1.648 0 -2.983 -1.335 -2.983 -2.983 c 0 -1.648 1.336 -2.983 2.983 -2.983 h 20.041 c 1.648 0 2.983 1.335 2.983 2.983 C 68.349 74.082 67.013 75.417 65.365 75.417 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217, 61, 118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDoList);
export default __webpack_public_path__ + "static/media/to-do-list.58cc658b94f5dda36cc2d4b49d7bf778.svg";
export { ForwardRef as ReactComponent };